import { render, staticRenderFns } from "./collectOperationalData.vue?vue&type=template&id=16e51d52&scoped=true"
import script from "./collectOperationalData.vue?vue&type=script&lang=js"
export * from "./collectOperationalData.vue?vue&type=script&lang=js"
import style0 from "./collectOperationalData.vue?vue&type=style&index=0&id=16e51d52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e51d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e51d52')) {
      api.createRecord('16e51d52', component.options)
    } else {
      api.reload('16e51d52', component.options)
    }
    module.hot.accept("./collectOperationalData.vue?vue&type=template&id=16e51d52&scoped=true", function () {
      api.rerender('16e51d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/collectOperationalData.vue"
export default component.exports